import { Component, ViewEncapsulation, EventEmitter, Output, Input } from '@angular/core';


@Component({
    selector: 'tk-vehicle-list-full-indicator-column-full',
    template: `
    <div class="tk-vehicle-list-full-indicator-column-full-container"
    (click)="toggel()"
    [ngClass]="{'tk-vehicle-list-full-indicator-column-full-is-visible' : isIndictorColumnFullOn}"></div>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['vehicle-list-full-inidicator-column-full.component.less']
})
export class VehicleListFullInidicatorColumnFullComponent {

    @Output()
    public onSwitchChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input()
    public isIndictorColumnFullOn = false;

    public toggel() {
        this.isIndictorColumnFullOn = !this.isIndictorColumnFullOn;
        this.onSwitchChange.emit(this.isIndictorColumnFullOn);
    }

}
